const GRAPH_SWITCHER = {
  percentages: false,
  integers: false,
};

export default GRAPH_SWITCHER;
